import * as React from "react";
import appHistory from "../../AppHistory";
import { DateTimeFormatter } from "../../Shared/Util/DateTimeFormatter";
import * as moment from 'moment';

interface IUpdateListItem {
  update: Api.INotificationViewModel;
}

class UpdateListItem extends React.Component<IUpdateListItem> {
  constructor(props: IUpdateListItem) {
    super(props);

    this.handleRowClick = this.handleRowClick.bind(this);
  }

  public render() {
    return (
      <tr onClick={this.handleRowClick}>
        <td>{this.props.update.referenceId}</td>
        <td className='title-link'>{this.props.update.responseTitle}</td>
        <td>{this.props.update.responseCategory}</td>
        <td>{DateTimeFormatter.ToShortDate(this.props.update.lastUpdatedArtefactDate)}</td>
        <td>{this.props.update.dateCreated ? DateTimeFormatter.ToShortDate(this.props.update.dateCreated) : '-'}</td>
        <td>{this.calculateDocUpdateDays()}</td>
        <td>{this.props.update.documentId || '-'}</td>
      </tr>
    )
  }

  private calculateDocUpdateDays(): string {
    const { dateCreated, lastUpdatedArtefactDate } = this.props.update;

    // If dateCreated (source document update date) is missing, return "-"
    if (!dateCreated || !lastUpdatedArtefactDate) {
      return '-';
    }

    const currentDate = moment();
    const artefactUpdatedMoment = moment(lastUpdatedArtefactDate);
    const docUpdatedMoment = moment(dateCreated);

    // First check if the artefact was updated after the source document's last update
    // If so, display "-" (no update pending)
    if (artefactUpdatedMoment.isAfter(docUpdatedMoment)) {
      return '-';
    }

    // Check if the difference between artefact's last update and source document's last update
    // is less than 24 hours AND one of them is close to the current date
    const hoursDiff = Math.abs(artefactUpdatedMoment.diff(docUpdatedMoment, 'hours'));
    const hoursFromCurrentToDoc = Math.abs(currentDate.diff(docUpdatedMoment, 'hours'));
    const hoursFromCurrentToArtefact = Math.abs(currentDate.diff(artefactUpdatedMoment, 'hours'));

    if (hoursDiff < 24 && (hoursFromCurrentToArtefact < 24 || hoursFromCurrentToDoc < 24)) {
      return '0';
    }

    // If the artefact was updated before source document update
    // According to requirements, we should display the number of days between
    // the current date and the source document's last update date (dateCreated)
    // This represents how many days have passed since the document was updated
    const daysDifference = currentDate.diff(docUpdatedMoment, 'days');

    // Count starts at 1 once the 24-hour mark has passed
    return daysDifference > 0 ? daysDifference.toString() : '0';
  }

  private handleRowClick(e: any) {
    if (this.props.update.isExternalArtefact) {
      appHistory.push(`/manage/${this.props.update.responseId}?isExternal=true&updateNotification=true`);
    } else {
      appHistory.push(`/manage/${this.props.update.responseId}?documentId=${this.props.update.documentId}`);
    }
  }
}

export { UpdateListItem };
